const label = "mb-1 block text-sm font-medium text-foreground/70";

const bankSelector = "flex flex-row items-center justify-center gap-4";

const bankButton = "p-4 rounded-lg border-2 cursor-pointer transition-all relative hover:border-primary/50";

const bankButtonSelected = "border-primary shadow-md opacity-100";

const bankButtonUnselected = "border-transparent hover:border-border/50 opacity-60 hover:opacity-80";

const bankLogoWrapper = "absolute -top-2 -right-2 w-6 h-6 bg-success rounded-full flex items-center justify-center shadow-sm";

const bankLogoSvg = "w-3 h-3 text-white";

const asaLogo = "h-5";

const procreditLogo = "h-14";

export { asaLogo, bankButton, bankButtonSelected, bankButtonUnselected, bankLogoSvg, bankLogoWrapper, bankSelector, procreditLogo, label };
